// 封装各个模块的请求
import request from '@/utils/request'
// import qs from 'qs'
// 引入 Vuex 的数据
// import store from '@/store'

// 用户登录接口
export const login = data => {
  return request({
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    url: 'platform-user/login',
    data: JSON.stringify(data)
  })
}

// // 用户基本信息接口
// export const getUserInfo = () => {
//   // return request({
//   //   method: 'GET',
//   //   url: 'user/getUserInfo'
//   //   // headers: {
//   //   //   [store.state.user.tokenName]:
//   //   //   JSON.parse(window.localStorage.getItem('user_scnu')) ||
//   //   //   store.state.user.tokenValue
//   //   // }
//   // })
//   return store.state.login_return
// }

// 获取用户信息
export const getUserInfo = () => {
  return request({
    method: 'GET',
    url: '/platform-user/detailUser'
  })
}

// 退出
export const logOut = () => {
  return request({
    method: 'GET',
    url: '/platform-user/logout'
  })
}

// 获取用户消息
export const getUserMsg = (msgType) => {
  return request({
    method: 'POST',
    url: '/platform-message/get_msg',
    data: msgType
  })
}
export const getUserSystemMsg = (params) => {
  return request({
    method: 'POST',
    url: '/platform-message/system-message/page',
    data: params
  })
}
// 获取下载文件
export const downloadFileFromServer = (fileURL) => {
  return request({
    method: 'POST',
    url: '/platform-message/get_download_file',
    data: fileURL,
    responseType: 'blob' // 设置响应类型为 blob
  })
}

export const getUploadMsg = (data) => {
  return request({
    method: 'POST',
    url: '/platform-message/get_upload_msg',
    data: data
  })
}

// 获取用户上传文件
export const downloadUploadFileFromServer = (data) => {
  return request({
    method: 'POST',
    url: '/platform-message/get_upload_file',
    data: data,
    responseType: 'blob' // 设置响应类型为 blob
  })
}

export const getPlatformBasicInfo = () => {
  return request({
    method: 'GET',
    url: '/platform-user/getPlatformBasicInfo'
  })
}
